module.exports = __webpack_public_path__ + "img/distributiondocquery.20d09e82.png";